
const NewUICampaignHistoryPreferenceKey = 'WebApp.Next.CampaignHistory';

export const getRecentCampaigns = (preferenceService) => {
  const campaignList =
    (preferenceService.findByNameAtAccountLevel(NewUICampaignHistoryPreferenceKey)
    && preferenceService.findByNameAtAccountLevel(NewUICampaignHistoryPreferenceKey).Data) || [];
  return campaignList;
};
